import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AuthUser from '../services/AuthUser';
import { useParams, useNavigate } from 'react-router-dom';
import Footer from '../view/footer';
import WhatsAppScrollButton from '../view/floatingwhatsApp';
import CircularScrollProgress from '../view/Circularprogress';

const TicketDetail = () => {
  const [ticket, setTicket] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [commentText, setCommentText] = useState('');
  const [statusMsg, setStatusMsg] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();
  const { http } = AuthUser();

  useEffect(() => {
    http.get(`/tickets/${id}`).then(res => {
      console.log('Ticket Response:', res.data); // ✅ Check this
      setTicket(res.data.ticket);
      setAttachments(res.data.attachments);
    });
  }, [id]);

  const handleCommentSubmit = (e) => {
    e.preventDefault();
    setErrors({});
    setStatusMsg('');

    http.post(`/tickets/comments/${id}`, {
      comment_text: commentText,
    })
      .then(res => {
        setStatusMsg('Comment added successfully.');
        setCommentText('');
        return http.get(`/tickets/${id}`);
      })
      .then(res => {
        setTicket(res.data.ticket);
        setAttachments(res.data.attachments);
      })
      .catch(err => {
        if (err.response?.data?.errors) {
          setErrors(err.response.data.errors);
        } else {
          console.error('Error adding comment:', err);
        }
      });
  };

  if (!ticket) {
    return <div>Loading...</div>;
  }

  return (
    <>
    <div className="container" style={{ marginTop: "2rem"}}>
      {statusMsg && <div className="alert alert-success">{statusMsg}</div>}
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div className="card">
            <div className="card-header">Ticket #{ticket.id}</div>
            <div className="card-body">
              <table className="table table-bordered table-striped">
                <tbody>
                  <tr>
                    <th>Title</th>
                    <td>{ticket.title}</td>
                  </tr>
                  <tr>
                    <th>Content</th>
                    <td dangerouslySetInnerHTML={{ __html: ticket.content }}></td>
                  </tr>
                  <tr>
                    <th>Attachments</th>
                    <td>
                      {attachments.length > 0 ? (
                        attachments.map((file, idx) => (
                          <div key={idx}>
                            <a href={file.url} target="_blank" rel="noopener noreferrer">
                              {file.file_name}
                            </a>
                          </div>
                        ))
                      ) : (
                        <span>No attachments</span>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{ticket.status?.name}</td>
                  </tr>
                  <tr>
                    <th>Author Name</th>
                    <td>{ticket.author_name}</td>
                  </tr>
                  <tr>
                    <th>Author Email</th>
                    <td>{ticket.author_email}</td>
                  </tr>
                <tr>
  <th>Comments</th>
  <td>
    {ticket.comments && ticket.comments.length > 0 ? (
      ticket.comments.map((comment, idx) => (
        <div key={idx} className="mb-3">
          <p>
            <strong>
              <a href={`mailto:${comment.author_email}`}>{comment.author_name}</a>
            </strong> ({new Date(comment.created_at).toLocaleString()})
          </p>
          <p>{comment.comment_text}</p>

          {/* Comment attachments */}
          {comment.media && comment.media.length > 0 && (
            <div className="mt-2">
              <strong>Attachments:</strong>
            <div
  className="d-flex flex-wrap mt-1"
  style={{
    maxHeight: '400px',  // increased from 200px → 400px
    overflowY: 'auto'
  }}
>
                {comment.media.map((file, fidx) => (
                  <div
                    key={fidx}
                    className="border rounded  me-2 mb-2 text-center"
                    style={{ width: "160px" }}
                  >
                    {file.mime_type.startsWith('image/') ? (
                      <a href={file.original_url} target="_blank" rel="noopener noreferrer">
                        <img
                          src={file.original_url}
                          className="img-thumbnail mb-1"
                          style={{ maxHeight: "120px" }}
                        />
                      </a>
                    ) : (
                      <a href={file.original_url} target="_blank" rel="noopener noreferrer">
                        {file.file_name}
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {idx !== ticket.comments.length - 1 && <hr />}
        </div>
      ))
    ) : (
      <p>There are no comments.</p>
    )}
  </td>
</tr>

                </tbody>
              </table>

              <form onSubmit={handleCommentSubmit}>
                <div className="form-group">
                  <label htmlFor="comment_text">Leave a comment</label>
                  <textarea
                    id="comment_text"
                    className={`form-control ${errors.comment_text ? 'is-invalid' : ''}`}
                    rows="3"
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    required
                  />
                  {errors.comment_text && (
                    <div className="invalid-feedback">{errors.comment_text[0]}</div>
                  )}
                </div>
                <div className="d-flex">
                  <button type="submit" className="btn btn-primary me-2">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div className="space40 bg-white">  </div>
        <WhatsAppScrollButton />
        <Footer />
        <CircularScrollProgress />
      </>
  );
};

export default TicketDetail;
